// SidebarItems.js
import HomeIcon from '@mui/icons-material/Home';
import AssignmentIcon from '@mui/icons-material/Assignment';
import EventIcon from '@mui/icons-material/Event';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PeopleIcon from '@mui/icons-material/People';
import ScienceIcon from '@mui/icons-material/Science';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import HotelIcon from '@mui/icons-material/Hotel';
import GroupIcon from '@mui/icons-material/Group';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { RiAdvertisementLine } from 'react-icons/ri';
import { Feedback, HealthAndSafety, Hub, LocalHospital, QuestionMark } from '@mui/icons-material';
import { AlertOctagonIcon, Bell, Building, Code, MessageCircleCode, MicroscopeIcon, PillIcon, ShareIcon, ShoppingBag } from 'lucide-react';
import { ShieldAlert } from 'lucide-react';
import { AdsClickRounded, Person2Rounded } from '@mui/icons-material';
import { FaCertificate } from 'react-icons/fa6';

export const getSidebarItems = () => {
  const adminIds = process.env.REACT_APP_ADMIN_ID?.split(",") || [];
  const userId = sessionStorage.getItem("userId");
  const role = sessionStorage?.getItem("role");

  const isAdmin = adminIds.includes(userId);
  const isDoctor = role === "Doctor";
  console.log(adminIds)

  const financeModuleUrl = sessionStorage.getItem('financeModuleUrl');

  // Trivia status checks
  const today = new Date().toDateString();
  const triviaDateGenerated = localStorage.getItem('triviaDateGenerated');
  const triviaQuestions = localStorage.getItem('triviaQuestions');
  const triviaCompleted = localStorage.getItem('triviaCompleted');
  const triviaDismissed = localStorage.getItem('triviaDismissed');

  // New trivia = generated today + not completed + questions exist
  const hasNewTrivia =
    triviaDateGenerated === today &&
    triviaQuestions &&
    triviaCompleted !== today;


  const baseItems = [
    { label: 'Home', path: '/landing', icon: <HomeIcon /> },
    {
      label: 'B2C Marketplace',
      icon: <LocalPharmacyIcon />,
      children: [
        { label: 'Medications', path: '/marketplace/pharmacy', icon: <PillIcon /> },
        { label: 'Lab Services', path: '/marketplace/lab', icon: <ScienceIcon /> },
        { label: 'Medical Services', path: '/marketplace/services', icon: <HealthAndSafety /> },
      ],
    },
    {
      label: 'B2B Marketplace',
      icon: <Building />,
      children: [
        { label: 'Merchants', path: '/marketplace/merchants', icon: <ShoppingBag /> },


      ],
    },
    { 
      label: 'Banned Medications', 
      path: '/marketplace/banned-medications', 
      icon: <AlertOctagonIcon /> },

    {
      label: 'Billing & Finance',
      path: '/billing',
      icon: <AccountBalanceWalletIcon />,

    },
    { label: "Doctors", path: '/doctors', icon: <PeopleIcon /> },
    { label: 'Articles', path: '/articles', icon: <AssignmentIcon /> },
    {
      label: 'Health Scenarios',
      path: '/trivia',
      icon: <QuestionMark />,
      badge: hasNewTrivia ? 'new' : null,
    },

    { label: 'Lab Reports', path: '/laboratory', icon: <MicroscopeIcon /> },
    { label: 'Prescriptions', path: '/pharmacy', icon: <PillIcon /> },
    { label: 'Laboratories', path: '/labs-page', icon: <MicroscopeIcon /> },
    { label: 'Pharmacies', path: '/pharmacy-page', icon: <LocalPharmacyIcon /> },
    { label: 'Hospitals', path: '/hospitals', icon: <LocalHospital /> },
    { label: 'Other Health Care Providers', path: '/other-providers', icon: <HealthAndSafety /> },
    { label: 'Business Profile', path: '/business-center', icon: <HotelIcon /> },
    { label: 'Account Activity', path: '/account-activities', icon: <Hub /> },
    {
      label: 'Socials & Community',
      icon: <GroupIcon />,
      children: [
        { label: 'Socials', path: '/socials', icon: <PeopleIcon /> },
        { label: 'Groups', path: '/groups-page', icon: <GroupIcon /> },
        // { label: 'Chat', path: '/chat', icon: <MessageCircleCode /> },
        { label: 'Notifications', path: '/notifications', icon: <Bell /> },
      ],
    },
    { label: 'Career/Certificates', path: '/career', icon: <FaCertificate /> },
    // { label: 'Submit Feedback', path: '/submit-feedback', icon: <Feedback /> }, // move to end
  ];

  // Add doctor-only items
  if (isDoctor) {
    baseItems.splice(1, 0,
      { label: 'Appointments', path: '/appointments', icon: <EventIcon /> },
      { label: 'Patients', path: '/patients', icon: <PeopleIcon /> },
      { label: 'Admissions', path: '/admissions', icon: <AssignmentIcon /> }
    );
  }

  // Add admin-only items
  if (isAdmin) {
    baseItems.push({
      label: 'Advert Management',
      path: '/adverts',
      icon: <AdsClickRounded />
    });
  }

  // Always add Submit Feedback as the last item
  baseItems.push({ label: 'Submit Feedback', path: '/submit-feedback', icon: <Feedback /> });
  baseItems.push({ label: 'Referral Code', path: '/health-record', icon: <ShareIcon /> });

  // Add logout at the end
  // baseItems.push({ label: 'Log Out', path: '/logout', icon: <ExitToAppIcon /> });

  return baseItems;
};
